<template>
  <div>
    <v-row v-if="list.length > 0" class="mt-0 ma-2">
      <v-col cols="12" sm="6" v-for="(item, index) in list" :key="index">
        <OccurrenceItemCard
          :item="item"
          :editable="editable"
        ></OccurrenceItemCard>
      </v-col>
    </v-row>
    <div v-else class="d-flex justify-center">
      <span class="body-1 ma-10 primary--text font-weight-medium"
        >No hay avistamientos registrados</span
      >
    </div>
  </div>
</template>

<script>
import OccurrenceItemCard from "../Occurrence/OccurrenceItemCard";
export default {
  components: { OccurrenceItemCard },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style></style>
